import { Card, CardHeader } from 'reactstrap'
import MenuCardBody from '../MenuCardBody'
import './MenuCard.css'

export default function MenuCard({ card }) {
  // console.log(`MenuCard rendered: ${card.title}`)

  return (
    <Card className="menu-card">
      <CardHeader className="menu-card-header">{card.title}</CardHeader>
      <MenuCardBody className="menu-card-body" card={card} />
    </Card>
  )
}
